var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1600 1200" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "80 100 1460 1200",
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            transform: "matrix(2.76625 2.46974 -2.47478 2.7719 213.72 273.715)",
          },
        },
        [
          _c("defs", [
            _c("path", {
              attrs: {
                id: "SVGID_1_",
                transform: "rotate(-48.24 71.998 43.996)",
                d: "M-91.5-223h327v534h-327z",
              },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_1_" },
            }),
          ]),
          _c("g", { staticStyle: { "clip-path": "url(#SVGID_2_)" } }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M110.8 80c-.1 0-.2 0-.3-.1-5.4-3.3-10.9-6.9-16.1-10.3-10.8-7-22-14.3-33.7-20.1-20.4-10-39.3-13.4-56.2-10.3-.3 0-.5-.1-.6-.4 0-.3.1-.5.4-.6 17.1-3.2 36.2.3 56.8 10.4 11.8 5.8 23 13.1 33.8 20.1 5.2 3.4 10.7 7 16.1 10.3.2.1.3.5.2.7-.1.2-.3.3-.4.3z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M27 55.6c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7L37.2 40c.2-.2.5-.3.7-.1.2.2.3.5.1.7L27.4 55.4c-.1.2-.2.2-.4.2zM22.6 54.2c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l10.5-14.6c.2-.2.5-.3.7-.1.2.2.3.5.1.7L23 54c-.1.1-.2.2-.4.2zM18.2 52.7c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l9.7-13.6c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-9.7 13.6c-.1.1-.3.2-.4.2zM13.8 51.2c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l9.1-12.7c.2-.2.5-.3.7-.1.2.2.3.5.1.7L14.2 51c-.1.1-.3.2-.4.2zM9.3 49.7c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l8.3-11.6c.2-.2.5-.3.7-.1.2.2.3.5.1.7L9.8 49.5c-.1.1-.3.2-.5.2zM4.9 48.2c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l7.1-9.9c.2-.2.5-.3.7-.1.2.2.3.5.1.7L5.3 48c-.1.2-.2.2-.4.2zM.5 46.8c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l5.6-7.8c.2-.2.5-.3.7-.1.2.2.3.5.1.7L.9 46.6c-.1.1-.2.2-.4.2z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M37.7 40.7c-.2 0-.4-.1-.5-.3l-7.5-16.6c-.1-.3 0-.6.3-.7.3-.1.6 0 .7.3L38.2 40c.1.3 0 .6-.3.7h-.2zM32.4 39.6c-.2 0-.4-.1-.5-.3l-6.7-15c-.1-.3 0-.6.3-.7.3-.1.6 0 .7.3l6.7 15c.1.3 0 .6-.3.7h-.2zM27.1 38.8c-.2 0-.4-.1-.5-.3l-6.1-13.6c-.1-.3 0-.5.3-.7.3-.1.6 0 .7.3l6.1 13.6c.1.3 0 .6-.3.7h-.2zM21.9 38.1c-.2 0-.4-.1-.5-.3l-5.5-12.3c-.1-.3 0-.6.3-.7.3-.1.5 0 .7.3l5.5 12.3c.1.3 0 .6-.3.7h-.2zM17 38c-.2 0-.4-.1-.5-.3l-5.2-11.6c-.1-.3 0-.6.3-.7.3-.1.6 0 .7.3l5.2 11.6c.1.3 0 .6-.3.7H17zM12.1 38c-.2 0-.4-.1-.5-.3l-5-11.1c-.1-.3 0-.6.3-.7.3-.1.6 0 .7.3l5 11.1c.1.3 0 .6-.3.7h-.2zM7.5 38.7c-.2 0-.4-.1-.5-.3L2 27.2c-.1-.3 0-.5.3-.7.3-.1.6 0 .7.3L8 38c.1.3 0 .5-.3.7h-.2z",
              },
            }),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M32.1 79.7c-.1 0-.3-.1-.4-.2-.2-.2-.2-.5 0-.7 12.6-12 30.5-19.4 53.3-22.2 13.1-1.6 26.4-1.5 39.4-1.5 6.3 0 12.7 0 19.1-.1.3 0 .5.2.5.5s-.2.5-.5.5c-6.4.2-12.8.1-19.1.1-12.9 0-26.2-.1-39.2 1.5-22.6 2.7-40.3 10.1-52.8 21.9-.1.1-.2.2-.3.2z",
                },
              }),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M60 81c-.3 0-.5-.2-.5-.5l.8-18.2c0-.3.3-.5.5-.5.3 0 .5.2.5.5l-.8 18.2c0 .3-.3.5-.5.5zM55.5 82.2c-.1 0-.1 0 0 0-.3 0-.5-.2-.5-.5l.8-17.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5L56 81.7c-.1.3-.3.5-.5.5zM50.9 83.4c-.3 0-.5-.2-.5-.5l.8-16.7c0-.3.3-.5.5-.5.3 0 .5.2.5.5l-.8 16.7c0 .3-.2.5-.5.5zM46.4 84.5c-.3 0-.5-.2-.5-.5l.7-15.5c0-.3.3-.5.5-.5.3 0 .5.2.5.5L46.9 84c0 .3-.2.5-.5.5zM41.9 85.7c-.3 0-.5-.2-.5-.5l.7-14.2c0-.3.3-.5.5-.5.3 0 .5.2.5.5l-.7 14.2c0 .3-.2.5-.5.5zM37.4 86.8c-.3 0-.5-.2-.5-.5l.6-12.1c0-.3.3-.5.5-.5.3 0 .5.2.5.5l-.6 12.1c0 .3-.2.5-.5.5zM32.9 88c-.3 0-.5-.2-.5-.5l.4-9.6c0-.3.3-.5.5-.5.3 0 .5.2.5.5l-.4 9.6c0 .3-.3.5-.5.5z",
                },
              }),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M60.8 62.7c-.1 0-.2 0-.3-.1l-15.3-9.9c-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1l15.3 9.9c.2.2.3.5.1.7-.1.1-.2.2-.4.2zM55.7 64.7c-.1 0-.2 0-.3-.1l-13.8-8.9c-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1L56 63.7c.2.2.3.5.1.7-.1.2-.2.3-.4.3zM50.9 66.9c-.1 0-.2 0-.3-.1l-12.5-8.1c-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1L51.2 66c.2.2.3.5.1.7-.1.1-.3.2-.4.2zM46.2 69.1c-.1 0-.2 0-.3-.1l-11.4-7.3c-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1l11.4 7.3c.2.2.3.5.1.7-.1.1-.3.2-.4.2zM41.9 71.7c-.1 0-.2 0-.3-.1l-10.7-6.9c-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1l10.7 6.9c.2.2.3.5.1.7-.1.1-.2.2-.4.2zM37.9 74.4c-.1 0-.2 0-.3-.1l-10.2-6.6c-.2-.2-.3-.5-.1-.7.1-.2.5-.3.7-.1l10.2 6.6c.2.2.3.5.1.7-.1.1-.3.2-.4.2zM34.4 77.4c-.1 0-.2 0-.3-.1l-10.3-6.7c-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1l10.3 6.7c.2.2.3.5.1.7-.1.1-.2.2-.4.2z",
                },
              }),
            ]),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M110.3 83.8c-.1 0-.2 0-.3-.1-4.3-3.6-8.9-7.1-13.2-10.5-9-7-18.4-14.3-26.6-22.6-14.4-14.4-22.8-29.4-25-44.7 0-.3.2-.5.4-.6.3 0 .5.2.6.4 2.2 15 10.5 29.9 24.8 44.1 8.2 8.2 17.5 15.5 26.5 22.5 4.4 3.4 8.9 6.9 13.3 10.5.2.2.2.5.1.7-.3.2-.4.3-.6.3z",
                },
              }),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M56.4 33.8c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l9.4-13.2c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-9.4 13.2c-.1.1-.2.2-.4.2zM54.1 30.3c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l9.2-12.9c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-9.2 12.9c-.1.1-.3.2-.4.2zM52.2 26.1c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l8.6-12c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-8.6 12c-.1.2-.2.2-.4.2zM50.3 22.1c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l8-11.2c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-8 11.2c-.1.1-.3.2-.4.2zM48.4 17.8c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l7.3-10.3c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-7.3 10.3c-.1.2-.2.2-.4.2zM47 13c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7l6.3-8.8c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-6.3 8.8c-.1.2-.2.2-.4.2zM45.8 7.9c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7L50.3.2c.2-.2.5-.3.7-.1.2.2.3.5.1.7l-4.9 6.9c-.1.2-.2.2-.4.2z",
                },
              }),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "m56.3 33.9-16.1-1.5c-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5l16.1 1.5c.3 0 .5.3.5.5 0 .3-.2.5-.5.5zM53.9 29.7s-.1 0 0 0l-14.5-1.3c-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5l14.5 1.3c.3 0 .5.3.5.5 0 .3-.3.5-.5.5zM51.7 25.6l-13.2-1.2c-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5l13.1 1.2c.3 0 .5.3.5.5.1.3-.1.5-.4.5zM49.7 21.4c-.1 0-.1 0 0 0l-12-1.1c-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5l12 1.1c.3 0 .5.3.5.5-.1.3-.3.5-.5.5zM48.1 17.3l-11.3-1c-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5l11.2 1c.3 0 .5.3.5.5.1.3-.2.5-.4.5zM46.8 13.2c-.1 0-.1 0 0 0l-10.8-1c-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5l10.7 1c.3 0 .5.3.5.5 0 .3-.2.5-.4.5zM46 9.2l-10.9-1c-.3 0-.5-.3-.5-.5 0-.3.3-.5.5-.5l10.9 1c.3 0 .5.3.5.5 0 .3-.2.5-.5.5z",
                },
              }),
            ]),
          ]),
        ]
      ),
      _c(
        "g",
        { attrs: { transform: "matrix(3.38235 0 0 3.36522 1214 166)" } },
        [
          _c("defs", [
            _c("path", {
              attrs: { id: "SVGID_3_", d: "M-121.5-136h345v387h-345z" },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_4_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_3_" },
            }),
          ]),
          _c("g", { staticStyle: { "clip-path": "url(#SVGID_4_)" } }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M.5 115c-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.1-.7 3.8-5.5 7.9-11 11.8-16.3C20 87 28.4 75.7 35.2 63.7 47 42.8 51.9 23.1 49.6 5.1c0-.3.2-.5.4-.6.3 0 .5.2.6.4C52.9 23.1 48 43 36.1 64.1c-6.8 12.1-15.2 23.4-23.4 34.4-3.9 5.3-8 10.8-11.8 16.3-.1.1-.2.2-.4.2z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M46.4 40.5c-.1 0-.2 0-.3-.1L31.2 28.3c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1l14.9 12.1c.2.2.2.5.1.7-.1.1-.2.2-.4.2zM48 35.7c-.1 0-.2 0-.3-.1L33 23.7c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1l14.7 11.9c.2.2.2.5.1.7-.1.2-.2.2-.4.2zM48.8 30.3c-.1 0-.2 0-.3-.1L34.9 19.1c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1l13.7 11.1c.2.2.2.5.1.7-.2.2-.3.2-.5.2zM49.8 25c-.1 0-.2 0-.3-.1L36.7 14.6c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1L50 24.2c.2.2.2.5.1.7-.1.1-.2.1-.3.1zM50.5 19.6c-.1 0-.2 0-.3-.1L38.5 10c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1l11.7 9.5c.2.2.2.5.1.7-.1.1-.2.2-.4.2zM50.6 13.7c-.1 0-.2 0-.3-.1l-10-8.1c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1l10 8.1c.2.2.2.5.1.7-.1.1-.2.2-.4.2zM50.4 7.4c-.1 0-.2 0-.3-.1L42.2.9c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7-.1l7.9 6.4c.1.2.2.5 0 .7-.1.1-.3.2-.4.2z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M46.6 40.6c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.6l18-6.8c.3-.1.5 0 .6.3.1.3 0 .5-.3.6l-18 6.8h-.1zM48.1 35c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.6L64.1 28c.3-.1.5 0 .6.3.1.3 0 .5-.3.6L48.2 35h-.1zM49.2 29.5c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.6L63.7 23c.3-.1.5 0 .6.3.1.3 0 .5-.3.6l-14.7 5.6h-.1zM50.3 24.1c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.6l13.3-5c.3-.1.5 0 .6.3.1.3 0 .5-.3.6l-13.3 5h-.1zM50.7 18.9c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.6L63 13.3c.3-.1.5 0 .6.3.1.3 0 .5-.3.6l-12.5 4.7h-.1zM51 13.8c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.6l12-4.5c.3-.1.5 0 .6.3.1.3 0 .5-.3.6l-12 4.5H51zM50.6 8.9c-.2 0-.4-.1-.5-.3-.1-.3 0-.5.3-.6l12.1-4.6c.3-.1.5 0 .6.3.1.3 0 .5-.3.6L50.7 8.9h-.1z",
              },
            }),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M10.5 114.3c-.1 0-.2 0-.3-.1-.2-.2-.2-.5 0-.7 4.1-4.3 8-8.9 11.9-13.3 8-9.1 16.3-18.5 25.5-26.6 16-14.2 32.4-22.1 48.6-23.5.3 0 .5.2.5.5s-.2.5-.5.5c-16 1.4-32.1 9.2-48 23.3-9.2 8.1-17.4 17.5-25.4 26.5-3.9 4.4-7.9 8.9-11.9 13.3-.1.1-.2.1-.4.1z",
                },
              }),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M79.8 71.5c-.1 0-.2 0-.3-.1L66.3 60.6c-.2-.2-.2-.5-.1-.7s.5-.2.7-.1l13.3 10.7c.2.2.2.5.1.7-.2.2-.3.3-.5.3zM83.4 69c-.1 0-.2 0-.3-.1l-13-10.6c-.2-.2-.2-.5-.1-.7s.5-.2.7-.1l13 10.6c.2.2.2.5.1.7-.1.2-.2.2-.4.2zM87.1 66.6c-.1 0-.2 0-.3-.1l-12.1-9.8c-.2-.2-.2-.5-.1-.7s.5-.2.7-.1l12.1 9.8c.2.2.2.5.1.7-.2.1-.3.2-.4.2zM90.7 64.1c-.1 0-.2 0-.3-.1L79 54.9c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1L91 63.3c.2.2.2.5.1.7-.1.1-.3.1-.4.1zM94.3 61.7c-.1 0-.2 0-.3-.1l-10.4-8.4c-.2-.2-.2-.5-.1-.7s.5-.2.7-.1l10.4 8.4c.2.2.2.5.1.7-.1.1-.3.2-.4.2zM97.9 59.3c-.1 0-.2 0-.3-.1L88.7 52c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1l8.8 7.2c.2.2.2.5.1.7 0 .1-.2.2-.3.2zM101.5 56.8c-.1 0-.2 0-.3-.1l-7-5.6c-.2-.2-.2-.5-.1-.7.2-.2.5-.2.7-.1l7 5.6c.2.2.2.5.1.7-.1.2-.3.2-.4.2z",
                },
              }),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M66.5 60.6c-.1 0-.1 0 0 0-.3 0-.5-.3-.5-.6l2.6-16.9c0-.3.3-.5.6-.4.3 0 .5.3.4.6L67 60.2c-.1.2-.3.4-.5.4zM71 58.3c-.3 0-.5-.3-.5-.6l2.3-15.2c0-.3.3-.5.6-.4.3 0 .5.3.4.6l-2.3 15.2c0 .2-.2.4-.5.4zM75.6 56.3c-.1 0-.1 0 0 0-.3 0-.5-.3-.5-.6l2.1-13.8c0-.3.3-.5.6-.4.3 0 .5.3.4.6l-2.1 13.8c-.1.2-.3.4-.5.4zM80.1 54.4c-.1 0-.1 0 0 0-.3 0-.5-.3-.5-.6l1.9-12.5c0-.3.3-.5.6-.4.3 0 .5.3.4.6L80.6 54c-.1.2-.3.4-.5.4zM84.5 53s-.1 0 0 0c-.3 0-.5-.3-.5-.6l1.8-11.8c0-.3.3-.5.6-.4.3 0 .5.3.4.6L85 52.6c-.1.2-.3.4-.5.4zM88.9 51.8c-.1 0-.1 0 0 0-.3 0-.5-.3-.5-.6L90.1 40c0-.3.3-.5.6-.4.3 0 .5.3.4.6l-1.7 11.2c-.1.3-.3.4-.5.4zM93.2 51.3c-.1 0-.1 0 0 0-.3 0-.5-.3-.5-.6l1.7-11.4c0-.3.3-.5.6-.4.3 0 .5.3.4.6l-1.7 11.4c-.1.3-.3.4-.5.4z",
                },
              }),
            ]),
          ]),
        ]
      ),
      _c("g", { attrs: { transform: "matrix(3.29268 0 0 3.29293 257 187)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_5_", d: "M-376-227H704v652H-376z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_6_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_5_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_6_)" } },
          [
            _c("path", { staticClass: "st4", attrs: { d: "M0 0h328v198H0z" } }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M323.6 34.5H2.8V14.3c0-7.1 5.7-12.8 12.8-12.8h308v33z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M40.6 38.1H5.7V17.8c0-7 5.7-12.7 12.7-12.7h22.2v33z",
              },
            }),
            _c("path", {
              staticClass: "st4",
              attrs: { d: "M14.2 12.6h18v18h-18z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_7_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-110.267",
                  y1: "277.024",
                  x2: "-50.767",
                  y2: "277.024",
                  gradientTransform:
                    "matrix(3.2927 0 0 -3.2929 368.407 971.221)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_7_)" },
              attrs: { d: "M5.3 52h59.5v14H5.3z" },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: { d: "M59.2 52h59.5v14H59.2z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_8_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-77.568",
                  y1: "277.024",
                  x2: "-18.068",
                  y2: "277.024",
                  gradientTransform:
                    "matrix(3.2927 0 0 -3.2929 368.407 971.221)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_8_)" },
              attrs: { d: "M113 52h59.5v14H113z" },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: { d: "M166.8 52h59.5v14h-59.5z" },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_9_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "-44.869",
                  y1: "277.024",
                  x2: "14.631",
                  y2: "277.024",
                  gradientTransform:
                    "matrix(3.2927 0 0 -3.2929 368.407 971.221)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#eee" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#d6d7d8" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_9_)" },
              attrs: { d: "M220.7 52h59.5v14h-59.5z" },
            }),
            _c("path", {
              staticClass: "st6",
              attrs: { d: "M263.5 52H323v14h-59.5z" },
            }),
            _c("path", {
              staticStyle: { fill: "#f7f7f7" },
              attrs: {
                d: "M296 45.3H63.3c-3.3 0-6-2.7-6-6v-2.7c0-3.3 2.7-6 6-6H296c3.3 0 6 2.7 6 6v2.7c0 3.3-2.7 6-6 6z",
              },
            }),
            _c("circle", {
              staticClass: "st10",
              attrs: { cx: "74.5", cy: "41.2", r: "1.5" },
            }),
            _c("circle", {
              staticClass: "st10",
              attrs: { cx: "82.5", cy: "41.2", r: "1.5" },
            }),
            _c("circle", {
              staticClass: "st10",
              attrs: { cx: "90.5", cy: "41.2", r: "1.5" },
            }),
          ],
          1
        ),
      ]),
      _c(
        "g",
        {
          attrs: {
            transform: "matrix(-.5678 -2.0532 2.04023 -.56422 574.492 798.6)",
          },
        },
        [
          _c("defs", [
            _c("path", {
              attrs: {
                id: "SVGID_10_",
                transform: "rotate(-15.457 61.27 48.429)",
                d: "M-41.2-82.1h205v261h-205z",
              },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_11_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_10_" },
            }),
          ]),
          _c("g", { staticStyle: { "clip-path": "url(#SVGID_11_)" } }, [
            _c("path", {
              staticClass: "st10",
              attrs: {
                d: "M64.6 26h-6.5c-7.1 0-12.8-5.7-12.8-12.8v-.4C45.3 5.7 51 0 58.1 0h6.5c7.1 0 12.8 5.7 12.8 12.8v.4C77.3 20.3 71.6 26 64.6 26z",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                transform: "rotate(-90 61.323 22.068)",
                d: "M50.8 14.2h21V30h-21z",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                d: "M96.5 64.7v-6.5c0-7.1 5.7-12.8 12.8-12.8h.4c7.1 0 12.8 5.7 12.8 12.8v6.5c0 7.1-5.7 12.8-12.8 12.8h-.4c-7.1 0-12.8-5.7-12.8-12.8z",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                transform: "rotate(-90 101.453 61.483)",
                d: "M93.6 50.8h15.6v21.3H93.6z",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                d: "M26 46.1v6.5c0 7.1-5.7 12.8-12.8 12.8h-.4C5.7 65.4 0 59.7 0 52.6v-6.5C0 39 5.7 33.3 12.8 33.3h.4c7.1.1 12.8 5.8 12.8 12.8z",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                transform: "rotate(-90 21.068 49.39)",
                d: "M13.3 38.7h15.6V60H13.3z",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                d: "M97.4 30.1c0-2.9-2.4-5.2-5.3-5-20.4 1.3-40.8 1.3-61.4 0-2.9-.2-5.3 2.1-5.3 5 1.9 20.4 1.8 41 0 61.7 0 2.8 2.2 5 5 5 7.8-.5 15.4-.9 23-1-4.7-1.9-8-6.5-8-11.8v-.4c0-7.1 5.7-12.8 12.8-12.8h6.5c7.1 0 12.8 5.7 12.8 12.8v.4c0 5.3-3.2 9.9-7.8 11.8 7.7.1 15.4.5 22.9 1.1 2.8 0 5-2.2 5-5-1.5-22.6-1.8-43.7-.2-61.8z",
              },
            }),
            _c("path", {
              staticClass: "st12",
              attrs: {
                id: "texure_6_-i3",
                d: "M60 34.6c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1 0 .2 0 .3.1.3zm1.7-4.9c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1 0 .3.1.3zm20 3.3c.1.1.2.2.3.1.1 0 .1-.2.1-.3 0-.1-.2-.2-.3-.1-.1 0-.1.1-.1.3zm-29.8-6.2c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0v.3zm18.8 6.3c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-.4-5.2c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zM31.9 38c.2.2.4.2.6 0 .2-.2.2-.4 0-.6-.2-.2-.4-.2-.6 0-.2.2-.2.5 0 .6zm6.9-7c.2.2.4.2.6 0 .2-.2.2-.4 0-.6-.2-.2-.4-.2-.6 0-.1.2-.1.5 0 .6zm24.4 29.5c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4zm-.1-19.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4zm0-9.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.1-.4.4zM43.8 52.3c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.1.1 0 .4.2.5zm3.8-9.2c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.2.2-.1.4.2.5zm3.7-9.1c.2.1.5 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.5 0-.5.2-.1.2 0 .4.2.5zm30 18.2c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2 0-.3.3-.2.5zM73.7 34c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2 0-.3.3-.2.5zM35 48.4c.2.1.4 0 .5-.2.1-.2 0-.4-.1-.5-.2-.1-.4 0-.5.2-.2.1-.1.4.1.5zm4.1-7.8c.2.1.4 0 .5-.2.1-.2 0-.4-.1-.5-.2-.1-.4 0-.5.1-.2.2-.1.5.1.6zm3.9-8c0 .1.1.2.2.2.2.1.4 0 .5-.2.1-.2 0-.4-.1-.5-.1-.1-.2-.1-.3 0-.1 0-.1.1-.1.1-.2.2-.2.3-.2.4zm28.7 18.9c.1.2.3.3.5.2.2-.1.3-.3.2-.4-.1-.2-.3-.3-.4-.2-.3 0-.4.2-.3.4zm-5.2-16.8c.1.2.3.3.4.2.2 0 .3-.2.2-.4-.1-.2-.3-.3-.4-.2-.2 0-.3.2-.2.4zm-2.7-8.4c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.1.1-.2.3-.2.5zM52.6 48.9c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm.8-8.8c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm.8-8.7c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.1-.4.1-.4.3zm25 1.3c.1.2.4.2.5.1.2-.1.2-.4 0-.5-.1-.1-.3-.2-.5 0-.1 0-.1.2 0 .4 0-.1 0 0 0 0zm-24.4-.2c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-.6-5.1c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.1-.1-.2 0-.2.2zM44.5 29c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1-.1.2.1.3zm19.6-2.1c.1.1.2.1.3.1.1-.1.1-.2.1-.3 0-.1-.2-.1-.3-.1-.1 0-.2.2-.1.3zM30.6 32c.1.1.3 0 .3-.1.1-.1 0-.3-.1-.3-.1-.1-.3 0-.3.1 0 0 0 .2.1.3zm24.7 2.4c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.2-.2-.3-.2-.2 0-.2.1-.2.3zm-1.7-5.7c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.2-.2-.3-.2-.2 0-.2.1-.2.3zM43 32.6s.1 0 0 0c.2.1.3 0 .4-.2 0-.1-.1-.2-.2-.3-.1 0-.3.1-.3.2s0 .2.1.3zm21.7-6.4c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3-.1-.1.1-.1.3 0 .4zM35.5 57.7c0 .2.2.4.4.5.2 0 .4-.2.5-.4 0-.2-.2-.4-.4-.5-.3 0-.5.2-.5.4zm.8-10.1c0 .2.2.4.4.5.2 0 .4-.2.5-.4 0-.2-.2-.4-.4-.5-.2 0-.5.1-.5.4zm.8-10.2c0 .2.2.4.4.5.2 0 .4-.2.4-.4s-.2-.4-.4-.4c-.1-.1-.3.1-.4.3zm32.6-.3c.2.2.4.2.6.1.2-.2.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.2-.2.5-.1.6zm-6.5-7.7c.2.2.4.2.6.1.2-.2.2-.4 0-.6-.2-.2-.4-.2-.6 0-.2 0-.2.3 0 .5zM51.9 41.3c.1.2.3.3.5.3.2-.1.3-.3.3-.5-.1-.2-.3-.3-.5-.3-.2.1-.4.3-.3.5zm-3.1-9.6c.1.2.3.3.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.4-.5-.3-.2 0-.4.2-.3.5 0-.1 0-.1 0 0zM46.4 45c.1.2.3.4.5.3.2-.1.3-.3.3-.5-.1-.2-.3-.4-.5-.3-.2 0-.3.3-.3.5zm-2.7-9.8c.1.2.3.4.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.4-.5-.3-.2.1-.3.3-.3.5zM29 40.6c0 .2.1.4.4.5.2 0 .4-.1.5-.4 0-.2-.1-.4-.4-.5-.3 0-.5.2-.5.4zm1.2-10c0 .2.1.4.4.5.2 0 .4-.1.5-.4 0-.2-.1-.4-.4-.5-.3 0-.5.1-.5.4zm35 10.4c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6zM59 33c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.3.4-.1.6zm-11 4.3c.1.2.3.2.4.1.2-.1.2-.3.1-.4-.1-.2-.3-.2-.4-.1-.1 0-.1.2-.1.4zm-3.5-6.8c.1.2.3.2.4.1s.2-.3.1-.4c-.1-.2-.3-.2-.4-.1-.1.1-.1.3-.1.4zm-12.6 7.2c0 .2.2.3.3.3.2 0 .3-.2.3-.3 0-.2-.2-.3-.3-.3-.2 0-.4.1-.3.3zm-.7-7.6c0 .2.2.3.3.3.2 0 .3-.2.3-.3 0-.2-.2-.3-.3-.3-.2 0-.3.1-.3.3z",
              },
            }),
          ]),
        ]
      ),
      _c(
        "g",
        {
          attrs: {
            transform: "matrix(-.39713 -2.26715 2.26814 -.3973 834.5 806.624)",
          },
        },
        [
          _c("defs", [
            _c("path", {
              attrs: {
                id: "SVGID_12_",
                transform: "rotate(-9.936 61.272 48.435)",
                d: "M-50.2-92.6h223v282h-223z",
              },
            }),
          ]),
          _c("clipPath", { attrs: { id: "SVGID_13_" } }, [
            _c("use", {
              staticStyle: { overflow: "visible" },
              attrs: { "xlink:href": "#SVGID_12_" },
            }),
          ]),
          _c("g", { staticStyle: { "clip-path": "url(#SVGID_13_)" } }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M64.6 26h-6.5c-7.1 0-12.8-5.7-12.8-12.8v-.4C45.3 5.7 51 0 58.1 0h6.5c7.1 0 12.8 5.7 12.8 12.8v.4C77.3 20.3 71.6 26 64.6 26z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                transform: "rotate(-90 61.322 22.067)",
                d: "M50.7 14.2h21.2v15.7H50.7z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M96.5 64.7v-6.5c0-7.1 5.7-12.8 12.8-12.8h.4c7.1 0 12.8 5.7 12.8 12.8v6.5c0 7.1-5.7 12.8-12.8 12.8h-.4c-7.1 0-12.8-5.7-12.8-12.8z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                transform: "rotate(-90 101.452 61.482)",
                d: "M93.6 50.9h15.7v21.2H93.6z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M26 46.1v6.5c0 7.1-5.7 12.8-12.8 12.8h-.4C5.7 65.4 0 59.7 0 52.6v-6.5C0 39 5.7 33.3 12.8 33.3h.4c7.1.1 12.8 5.8 12.8 12.8z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                transform: "rotate(-90 21.067 49.39)",
                d: "M13.2 38.8h15.7V60H13.2z",
              },
            }),
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M97.4 30.1c0-2.9-2.4-5.2-5.3-5-20.4 1.3-40.8 1.3-61.4 0-2.9-.2-5.3 2.1-5.3 5 1.9 20.4 1.8 41 0 61.7 0 2.8 2.2 5 5 5 7.8-.5 15.4-.9 23-1-4.7-1.9-8-6.5-8-11.8v-.4c0-7.1 5.7-12.8 12.8-12.8h6.5c7.1 0 12.8 5.7 12.8 12.8v.4c0 5.3-3.2 9.9-7.8 11.8 7.7.1 15.4.5 22.9 1.1 2.8 0 5-2.2 5-5-1.5-22.6-1.8-43.7-.2-61.8z",
              },
            }),
            _c("path", {
              staticClass: "st12",
              attrs: {
                id: "texure_6_-i4",
                d: "M60 34.6c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1 0 .2 0 .3.1.3zm1.7-4.9c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1 0 .3.1.3zm20 3.3c.1.1.2.2.3.1.1 0 .1-.2.1-.3 0-.1-.2-.2-.3-.1-.1 0-.1.1-.1.3zm-29.8-6.2c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0v.3zm18.8 6.3c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-.4-5.2c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zM31.9 38c.2.2.4.2.6 0 .2-.2.2-.4 0-.6-.2-.2-.4-.2-.6 0-.2.2-.2.5 0 .6zm6.9-7c.2.2.4.2.6 0 .2-.2.2-.4 0-.6-.2-.2-.4-.2-.6 0-.1.2-.1.5 0 .6zm24.4 29.5c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4zm-.1-19.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.2-.4.4zm0-9.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.1-.4.4zM43.8 52.3c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.1.1 0 .4.2.5zm3.8-9.2c.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2-.2.2-.1.4.2.5zm3.7-9.1c.2.1.5 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.5 0-.5.2-.1.2 0 .4.2.5zm30 18.2c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2 0-.3.3-.2.5zM73.7 34c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2 0-.3.3-.2.5zM35 48.4c.2.1.4 0 .5-.2.1-.2 0-.4-.1-.5-.2-.1-.4 0-.5.2-.2.1-.1.4.1.5zm4.1-7.8c.2.1.4 0 .5-.2.1-.2 0-.4-.1-.5-.2-.1-.4 0-.5.1-.2.2-.1.5.1.6zm3.9-8c0 .1.1.2.2.2.2.1.4 0 .5-.2.1-.2 0-.4-.1-.5-.1-.1-.2-.1-.3 0-.1 0-.1.1-.1.1-.2.2-.2.3-.2.4zm28.7 18.9c.1.2.3.3.5.2.2-.1.3-.3.2-.4-.1-.2-.3-.3-.4-.2-.3 0-.4.2-.3.4zm-5.2-16.8c.1.2.3.3.4.2.2 0 .3-.2.2-.4-.1-.2-.3-.3-.4-.2-.2 0-.3.2-.2.4zm-2.7-8.4c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.1.1-.2.3-.2.5zM52.6 48.9c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm.8-8.8c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2 0-.4.1-.4.3zm.8-8.7c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4-.2-.1-.4.1-.4.3zm25 1.3c.1.2.4.2.5.1.2-.1.2-.4 0-.5-.1-.1-.3-.2-.5 0-.1 0-.1.2 0 .4 0-.1 0 0 0 0zm-24.4-.2c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2-.2.1-.2.2zm-.6-5.1c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.1-.1-.2 0-.2.2zM44.5 29c.1 0 .2 0 .3-.1 0-.1 0-.2-.1-.3-.1 0-.2 0-.3.1-.1.1-.1.2.1.3zm19.6-2.1c.1.1.2.1.3.1.1-.1.1-.2.1-.3 0-.1-.2-.1-.3-.1-.1 0-.2.2-.1.3zM30.6 32c.1.1.3 0 .3-.1.1-.1 0-.3-.1-.3-.1-.1-.3 0-.3.1 0 0 0 .2.1.3zm24.7 2.4c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.2-.2-.3-.2-.2 0-.2.1-.2.3zm-1.7-5.7c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.2-.2-.3-.2-.2 0-.2.1-.2.3zM43 32.6s.1 0 0 0c.2.1.3 0 .4-.2 0-.1-.1-.2-.2-.3-.1 0-.3.1-.3.2s0 .2.1.3zm21.7-6.4c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3-.1-.1.1-.1.3 0 .4zM35.5 57.7c0 .2.2.4.4.5.2 0 .4-.2.5-.4 0-.2-.2-.4-.4-.5-.3 0-.5.2-.5.4zm.8-10.1c0 .2.1.4.4.5.2 0 .4-.2.5-.4 0-.2-.2-.4-.4-.5-.2 0-.5.1-.5.4zm.8-10.2c0 .2.2.4.4.5.2 0 .4-.2.4-.4s-.2-.4-.4-.4c-.1-.1-.3.1-.4.3zm32.6-.3c.2.2.4.2.6.1.2-.2.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.2-.2.5-.1.6zm-6.5-7.7c.2.2.4.2.6.1.2-.2.2-.4 0-.6-.2-.2-.4-.2-.6 0-.2 0-.2.3 0 .5zM51.9 41.3c.1.2.3.3.5.3.2-.1.3-.3.3-.5-.1-.2-.3-.3-.5-.3-.2.1-.4.3-.3.5zm-3.1-9.6c.1.2.3.3.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.4-.5-.3-.2 0-.4.2-.3.5 0-.1 0-.1 0 0zM46.4 45c.1.2.3.4.5.3.2-.1.3-.3.3-.5-.1-.2-.3-.4-.5-.3-.2 0-.3.3-.3.5zm-2.7-9.8c.1.2.3.4.5.3.2-.1.4-.3.3-.5-.1-.2-.3-.4-.5-.3-.2.1-.3.3-.3.5zM29 40.6c0 .2.1.4.4.5.2 0 .4-.1.5-.4 0-.2-.1-.4-.4-.5-.3 0-.5.2-.5.4zm1.2-10c0 .2.1.4.4.5.2 0 .4-.1.5-.4 0-.2-.1-.4-.4-.5-.3 0-.5.1-.5.4zm35 10.4c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6zM59 33c.1.2.4.2.6.1.2-.1.2-.4.1-.6-.1-.2-.4-.2-.6-.1-.2.1-.3.4-.1.6zm-11 4.3c.1.2.3.2.4.1.2-.1.2-.3.1-.4-.1-.2-.3-.2-.4-.1-.1 0-.1.2-.1.4zm-3.5-6.8c.1.2.3.2.4.1s.2-.3.1-.4c-.1-.2-.3-.2-.4-.1-.1.1-.1.3-.1.4zm-12.6 7.2c0 .2.2.3.3.3.2 0 .3-.2.3-.3 0-.2-.2-.3-.3-.3-.2 0-.4.1-.3.3zm-.7-7.6c0 .2.2.3.3.3.2 0 .3-.2.3-.3 0-.2-.2-.3-.3-.3-.2 0-.3.1-.3.3z",
              },
            }),
          ]),
        ]
      ),
      _c("g", { attrs: { transform: "matrix(1.5 0 0 1.49887 942 447)" } }, [
        _c("defs", [
          _c("path", {
            attrs: { id: "SVGID_14_", d: "M-55-110h330v661H-55z" },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_15_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_14_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_15_)" } },
          [
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "SVGID_16_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "2534.316",
                  y1: "-829.409",
                  x2: "3719.817",
                  y2: "-829.409",
                  gradientTransform: "matrix(.1143 0 0 -.1142 -289.673 7.946)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#SVGID_16_)" },
              attrs: {
                d: "M84.2 112.5S59.9 109 51.9 83.6c-.1-.2-3.1-13.1-5.1-16.4-2.4-3.9-8.5-6.3-12.2-6.2-4.5.1-12.6 1.6-22.2 4-2.1.5-12.4 5.3-12.4 7.5 0 1.7 1.7 2.9 3.4 3s3.2-.6 4.8-1.2c6.9-2.7 7.9-2.6 15.4-2.8 4.2-.1 8 0 7.3 1.6-1.8 4.3-7.2 3.6-11.8 3.2-1.5-.1-4.2.1-5.7.3-1.5.3-3.7 1.4-3.1 2.8 1.5 3.1 10 2.8 15.3 2.4 2.3-.1 4.5.3 6.5 1.4 2.7 1.5 5.5 4.3 6.4 7.1 6.5 19.4 15.9 48.4 51.9 54l-6.2-31.8z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_sleeve-i5_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "3619.051",
                  y1: "-918.353",
                  x2: "3789.068",
                  y2: "-2499.5",
                  gradientTransform: "matrix(.1112 0 0 -.1111 -292.594 -3.485)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#20266a" },
                  attrs: { offset: ".055" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#141e66" },
                  attrs: { offset: ".323" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#031361" },
                  attrs: { offset: ".696" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#000e5e" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_sleeve-i5_1_)" },
              attrs: {
                id: "L_sleeve-i5",
                d: "M129.4 68.1s-12 47.9-51.6 36.9l8.6 46.4s34.3-1.8 50.6-23.4c16.2-21.6-5.1-58-7.6-59.9",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                id: "R_shoe-i5",
                d: "m141.5 405.2 12.8 35.8H63.7s4.6-9 20.1-15.6 29.9-20.2 29.9-20.2h27.8",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                id: "L_shoe-i5",
                d: "M206.2 405.2 219 441h-90.6s4.6-9 20.1-15.6 29.9-20.2 29.9-20.2h27.8",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#0c96c8" },
              attrs: {
                id: "R_trousers-i5",
                d: "M180.2 152.5c-1.1 3.5-2.8 6.8-4.9 9.8-3.4 4.4-8.1 7.6-13.5 9.1 0 0 0 .2-5.9 1.5-8.2 1.4-9.1 1.6-9.1 1.6l-16-.9-7.8 30.6c-3.9 17.8-10.6 39.7-10.9 61.2-.5 30.8 1.8 139.8 1.8 139.8h27.7c22.7-22.6 20.5-40.2 22.2-76 1.7-35.8 7.1-24.3 5.5-58.3-1.7-34.1-.8-27.2 10.1-75.8 3.2-13.9 3.5-28.5.8-42.6z",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                id: "L_trousers-i5",
                d: "M207.2 355.7c-3.5-19.6-10-15.6-8.7-30.7 1.3-15.1-1.7-24.9-7.4-40.9-5.6-16-17.6-13.5-.2-66.5 7.1-21.1 7.8-43.9 2.1-65.4-1.2.3-2.5.5-3.8.8v-.9s-2.4.8-6.2 1.9c-1.1.2-2.3.3-3.6.5-.1.2-.2.5-.3.7-15.2 4.9-42.1 13.7-40.7 14.6 1.9 1.3-4.8 46.8-4.8 46.8l6.2 6.9c-.1.1-.2.1-.2.1l-6-7c-1.9 19.3-2.7 40.5-.9 58.9 2.2 23.1 45.8 129.7 45.8 129.7h27.7c0 .1 4.5-30 1-49.5z",
              },
            }),
            _c("path", {
              staticClass: "st19",
              attrs: {
                id: "texture-i5",
                d: "M187 169.9c-.1 0-.2 0-.2.1s0 .2.1.2.2 0 .2-.1 0-.2-.1-.2zm-4.2-1.7c-.1 0-.2 0-.2.1s0 .2.1.2.2 0 .2-.1c.1-.1 0-.2-.1-.2zm-9.1 15.3c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1.2-.1.1-.2zm-1.7-4.2c0-.1-.1-.1-.2-.1s-.1.1-.1.2.2.1.3.1v-.2zm8.1-3.2c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3.1.1.2.1.3 0 .1-.1.1-.2 0-.3 0 .1 0 .1 0 0zm-3.2-3.1c-.1-.1-.2-.1-.3 0 0 0 0 .1-.1.1 0 .1 0 .1.1.2h.2c.2-.1.2-.3.1-.3zm21.3 11.3c-.1-.1-.4-.1-.5 0-.1.1-.1.4 0 .5.1.1.4.1.5 0 .1-.1.1-.3 0-.5zm-6.5-5.6c-.1-.1-.4-.1-.5 0-.1.1-.1.4 0 .5s.4.1.5 0c.2-.1.1-.4 0-.5zm-6.5-5.6c-.1-.1-.4-.1-.5 0-.1.1-.1.4 0 .5.1.1.4.1.5 0 .2-.1.2-.4 0-.5.1 0 .1 0 0 0zm-13.1 32.8c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-.6-8.5c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-.6-8.6c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4c0-.1-.2-.3-.4-.3zm-.6-8.5c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm31.6-10.7c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5zm-8.1-2.7c-.2-.1-.4 0-.4.2-.1.2 0 .4.2.4.2.1.4 0 .4-.2 0-.1 0-.3-.2-.4zm-4.9 30.5c-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.2.3.3.5.2.3-.1.3-.3.2-.5zm-3.8-7.7c-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.2.3.3.5.2.2-.1.3-.3.2-.5zm-3.8-7.6c-.1-.2-.3-.2-.5-.2-.2.1-.2.3-.2.5.1.2.3.2.5.2.2-.1.3-.3.2-.5zm-3.8-7.6c-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5.1.2.3.2.5.2.2-.2.3-.4.2-.5zm-21.4 25.3c-.2-.1-.4 0-.4.2-.1.2 0 .4.2.4.2.1.4 0 .5-.2 0-.2-.1-.3-.3-.4zm2.7-8.1c-.2-.1-.4 0-.4.2-.1.2 0 .4.2.5.2.1.4 0 .5-.2 0-.3-.1-.5-.3-.5zm2.7-8.1c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.4.2.1.4 0 .4-.2.2-.2.1-.4-.1-.4zm34.8 9.9c-.1-.1-.3-.2-.4-.1-.1.1-.2.3-.1.4.1.1.3.2.4.1.1-.1.2-.3.1-.4zm-4.1-6.5c-.1-.1-.3-.2-.4-.1-.1.1-.2.3-.1.4.1.1.3.2.4.1.2 0 .2-.2.1-.4zm-4-6.5c0-.1-.1-.1-.1-.1h-.3c-.2.1-.2.3-.1.4.1.1.3.2.4.1.1 0 .1-.1.1-.2.1 0 0-.1 0-.2zm-4.1-6.4c-.1-.1-.3-.2-.4-.1-.2.1-.2.3-.1.4.1.2.3.2.4.1.2-.1.2-.3.1-.4zm-19.7 24.5c-.2 0-.3.1-.4.2 0 .2.1.3.2.4.2 0 .3-.1.4-.2.1-.1 0-.3-.2-.4zm1.7-7.4c-.2 0-.3.1-.4.2 0 .2.1.3.2.4.2 0 .3-.1.4-.2.1-.2 0-.3-.2-.4zm1.7-7.4c-.2 0-.3.1-.4.2 0 .2 0 .3.2.4.2 0 .3-.1.4-.2.1-.2 0-.4-.2-.4zm31.5-8.6c-.1-.1-.3-.1-.4.1-.1.1-.1.3.1.4.1.1.3.1.4-.1.1-.1 0-.3-.1-.4zm-6.2-4.4c-.1-.1-.3-.1-.4.1-.1.1-.1.3.1.4.1.1.3.1.4-.1.1-.1 0-.3-.1-.4zm-12.5 24.5c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-1.2-7.5c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.3c-.1-.4-.3-.5-.4-.4zm-1.3-7.6c-.2 0-.3.2-.3.3 0 .2.2.3.4.3s.3-.2.3-.4c0-.1-.2-.2-.4-.2zm-25.7 8.8c-.1-.1-.3-.1-.4.1-.1.1-.1.3.1.4.1.1.3.1.4-.1 0-.1 0-.3-.1-.4zm43.3-14.2c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3.1.1.2.1.3 0 .1-.1.1-.3 0-.3zm-3.1-3.3c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .3s.2.1.3 0c.1-.1.1-.2 0-.3zm-3.1-3.3c-.1-.1-.2-.1-.3 0-.1.1-.1.2 0 .2.1.1.2.1.3 0 .1 0 .1-.1 0-.2.1 0 .1 0 0 0zm-11.7 13.1c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.2-4.5c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.1-4.4c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2c0-.2-.1-.2-.2-.2zm8.7 5.2c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1.2-.1.1-.2zm-1.5-4.3c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1c0 .1.1-.1.1-.2zm-1.6-4.2c0-.1-.1-.1-.2-.1s-.1.1-.1.2.1.1.2.1.1-.1.1-.2zm15.3 10.1c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3.1.1-.1.1-.2.1-.3zm-2.8-4.3c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3s.2.1.3.1c.1-.1.2-.2.1-.3zm-2.8-4.4c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3 0 .2.1.2-.1.1-.2zm-15.9 12.4c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .2-.1.1-.3.1-.4-.1-.4zm1.1-5c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .3-.2 0-.2 0-.3-.2-.3zm1.1-5c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .2-.1.1-.3.1-.4-.1-.4zm1.1-5.1c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .2-.1.1-.2.1-.3-.1-.4zm23.9 1.9c-.1-.1-.2-.1-.3 0-.1.1 0 .2 0 .3.1.1.2 0 .3-.1.1 0 .1-.1 0-.2zm-4.2-2.9c-.1-.1-.2 0-.3 0-.1.1 0 .2.1.3.1.1.2 0 .3-.1 0 0 0-.1-.1-.2zm-12.2 13.8c0-.1-.1-.2-.2-.2s-.2.1-.2.2.1.2.2.2h.1c.1 0 .1-.1.1-.2zm-1.1-5.2c-.1 0-.2.1-.2.3 0 .1.1.2.3.2.1 0 .2-.1.2-.2-.1-.3-.2-.4-.3-.3zm-.9-5.1c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm20.2-3.4c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2 0-.4-.1-.5zm-10.6 34.8c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-1.4-8.7c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-1.3-8.7c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-1.4-8.7c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-1.4-8.7c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-30.3 26.2c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5zm5.2-7.1c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5zm37.8-9.3c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.1-.1.2-.3.1-.5zm-4.6-7.5c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.1-.1.2-.3.1-.5zm-19.8 27.9c-.2 0-.4.1-.4.3-.1.2.1.4.3.4.2 0 .4-.1.4-.3.1-.2-.1-.4-.3-.4zm2.1-8.6c-.2-.1-.4.1-.4.2 0 .2.1.4.3.4.2.1.4-.1.4-.3 0 0-.1-.2-.3-.3zm2.1-8.5c-.2 0-.4.1-.4.3 0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4zm2-8.6c-.2 0-.4.1-.4.3 0 .2.1.4.3.4.2 0 .4-.1.4-.3.1-.2-.1-.4-.3-.4zm21-.4c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.1-.1.2-.4.1-.5zm-21.8 28.9c-.2 0-.4.1-.4.3 0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.1-.1-.3-.3-.4zm1.7-8.6c-.2 0-.4.1-.4.3 0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.1-.1-.3-.3-.4zm1.7-8.6c-.2 0-.4.1-.4.3 0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.3-.3-.4zm1.7-8.6c-.2 0-.4.1-.4.3 0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.4-.3-.4zm11.3 12.5c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4c-.1-.2-.2-.4-.4-.3zm-1.8-8.6c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.4-.4-.3zm-1.7-8.6c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.4-.4-.3zM169.4 189c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.2-.2.1-.4-.1-.5zm4.9-7.3c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5zm4.9-7.3c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2 0-.4-.1-.5zm4.8-7.3c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.2-.2.1-.4-.1-.5zm20.6-.2c-.1-.1-.2-.2-.3-.2-.1.1-.2.2-.2.4.1.1.2.2.4.2.1-.1.2-.2.1-.4zm-20.6 18c-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.2.1-.4-.1-.4zm2.6-6.1c-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.2.1-.4-.1-.4zm2.6-6.1c-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.2.1-.3-.1-.4zm2.6-6.1c-.1-.1-.3 0-.4.2-.1.1 0 .3.2.4.1.1.3 0 .3-.1.1-.3.1-.4-.1-.5zm6.1 17.7c-.2 0-.3.1-.3.3 0 .1.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3zm.1-6.6c-.1 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3zm.1-6.7c-.2 0-.3.1-.3.3 0 .1.1.3.3.3.1 0 .3-.1.3-.2 0-.2-.2-.4-.3-.4zm-18.6-1c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4.1.1.3.1.4 0 .1-.2.1-.3 0-.4zm20.2-.2c-.1 0-.2 0-.2.1s0 .2.1.2.2 0 .2-.1c.1-.1 0-.2-.1-.2zm-4.2 5.7c-.1-.1-.2 0-.3.1-.1.1-.1.2.1.3.1.1.3 0 .3-.1.1-.1.1-.3-.1-.3.1 0 .1 0 0 0zm3.2-5.1c-.1-.1-.3 0-.3.1-.1.1 0 .3.1.3.1.1.2 0 .3-.1.1-.1.1-.2-.1-.3z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "sweater-i5_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4275.503",
                  y1: "-810.132",
                  x2: "3467.927",
                  y2: "-3436.883",
                  gradientTransform: "matrix(.1112 0 0 -.1111 -292.594 -3.485)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#141e66" },
                  attrs: { offset: ".323" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#031361" },
                  attrs: { offset: ".696" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#000e5e" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#sweater-i5_1_)" },
              attrs: {
                id: "sweater-i5",
                d: "M145.8 62.4c13.3 5.8 25.1 14.3 34.9 24.9 16.6 17.9 14.7 26 23.8 36.7s21.5 23.6 11.9 41.8c0 0-37 3.3-55.6-2.6l-31.6-95.1c.2 0 9.1 2.6 16.6-5.7z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_hand-i5_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "3252.023",
                  y1: "-1609.491",
                  x2: "2730.459",
                  y2: "-2316.125",
                  gradientTransform: "matrix(.1112 0 0 -.1111 -292.594 -3.485)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_hand-i5_1_)" },
              attrs: {
                id: "L_hand-i5",
                d: "M96.1 163.4s-12.6 8-22.8 10.9-10.9 2.1-14.6-2.3c-3.3-4.1-6.3-8.5-8.8-13.1-1.1-2.1-4.5-2.3-3.9 3.1.6 5.5 7.9 8.8 4.8 11.5-3.2 2.7-13.9 2.9-22 2.2-8-.7-12.4-.8-5.7 9.3s15 16.2 37.9 7.6 38.8-6.5 46.7-5.5l-11.6-23.7z",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                id: "L_sleeve-2-i5",
                d: "M129 69.7s9.4 29.4 5 48c-4 16.8-9.3 22.3-25.2 26.7-15.9 4.4-15.8 4.1-15.8 4.1l11.6 61.7s16.7 4.1 29.8-8.4 18.1-15.6 26.7-18.1c8.7-2.5 26.6-13.1 22.8-42.1s-11-49-38.2-79.2",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "neck-i5_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "3911.157",
                  y1: "-800.769",
                  x2: "3796.853",
                  y2: "-289.982",
                  gradientTransform: "matrix(.1112 0 0 -.1111 -292.594 -3.485)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#neck-i5_1_)" },
              attrs: {
                id: "neck-i5",
                d: "M127.6 53.6c1.3 4.7 1.9 9.6 1.8 14.5 0 0 7 4.6 16.4-5.7L139 45.3l-11.4 8.3",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#ffbeb6" },
              attrs: {
                id: "face-i5",
                d: "M109.9 20.5c0 .1-.1.2-.1.3v.1c-.2.5-.3 1-.4 1.5-1.5 5.6-6.2 9.5-6.5 11.1-.2 1.6 2.7 3 4.2 3.4 1.5.3 2.2 7.9 7.7 12.9 5.1 4.7 13.6 5.4 19.6 3 3.8-11.9 2.7-18-8.4-25.1-12.1-7.7-10.3-16.1-10.3-16.1-2.7 2.4-4.6 5.5-5.8 8.9z",
              },
            }),
            _c("path", {
              staticClass: "st24",
              attrs: {
                id: "hair-i5",
                d: "M166.7 35.5c-2.1-6.3-2.5-14-2.8-16.9-.4-3.9-6.8-16.7-21.1-18.3s-32.6.9-33 20.4c1.2-3.5 3.2-6.7 5.8-9.3 0 0-1.8 8.4 10.3 16.1 1.3.8 2.5 1.7 3.7 2.6 5.2 8 7.1 17.2-1.2 25.5-.5.5.3 1.2.8.7 7.7-7.7 7-16.2 2.9-23.9 5.8 6 5.1 12.4 1.1 23.7 0 0 20.9 7.4 41.5-2.5-.2-4.5-1.9-8.7-4.8-12.1-1-1.3-1.8-2.7-2.4-4.2 4.7 4.7 9.9 9.1 8.5 16.1-.1.3.1.6.4.6.3.1.5-.1.6-.4 1.5-8.1-5.4-12.7-10.3-18.1z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#9ac3f9" },
              attrs: {
                id: "eye-i5",
                d: "M115.1 28.1c-1.8 1.7-4.6 1.7-6.3-.1-.6-.6-1-1.4-1.2-2.3-.1-.7.9-1 1-.3.3 1.8 2 3.1 3.8 2.9.7-.1 1.3-.4 1.9-.9.6-.4 1.3.3.8.7z",
              },
            }),
          ],
          1
        ),
      ]),
      _c("g", { attrs: { transform: "matrix(1.36981 0 0 1.368 336 428)" } }, [
        _c("defs", [
          _c("path", { attrs: { id: "SVGID_17_", d: "M-49-92h363v684H-49z" } }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_18_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_17_" },
          }),
        ]),
        _c(
          "g",
          { staticStyle: { "clip-path": "url(#SVGID_18_)" } },
          [
            _c("path", {
              staticClass: "st17",
              attrs: {
                id: "L_shoe-i6",
                d: "M90 458.5 75.1 500h105.2s-5.4-10.4-23.4-18.1c-18-7.7-34.8-23.4-34.8-23.4H90",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                id: "R_shoe-i6",
                d: "M14.9 458.5 0 500h105.2s-5.4-10.4-23.4-18.1c-18-7.7-34.8-23.4-34.8-23.4H14.9",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "L_trousers-i6_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "5044.878",
                  y1: "-4319.664",
                  x2: "3387.001",
                  y2: "-2385.473",
                  gradientTransform: "matrix(.1015 0 0 -.1014 -310.6 1.752)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#23286b" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#151a4f" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#L_trousers-i6_1_)" },
              attrs: {
                id: "L_trousers-i6",
                d: "M45.1 168.9c-2.7 13.2-3.3 29.7 1.1 49 12.7 55.6 13.7 47.8 11.7 86.8s4.4 25.8 6.3 66.8c1.9 41-.6 61.2 25.8 87h32.1s2.6-124.9 2-160.2c-.4-24.7-8.2-49.7-12.7-70.2l-9.9-54.5",
              },
            }),
            _c("path", {
              staticClass: "st10",
              attrs: {
                id: "R_trousers-i6",
                d: "M99.2 242.4s-9.3-55.2-8.5-68l-59.6-9.6-.8 3.7c-6.6 24.7-5.8 50.7 2.4 74.9 20.2 60.6 6.3 57.8-.2 76.1-6.6 18.3-10.1 29.6-8.6 46.9 1.5 17.3-6 12.7-10.1 35.2-4 22.4 1.1 56.8 1.1 56.8H47s50.7-122 53.2-148.5c2-21 1.2-45.3-1-67.5z",
              },
            }),
            _c("path", {
              staticClass: "st19",
              attrs: {
                id: "texture-2-i6",
                d: "M65.8 195.6c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1 0 .1 0 .3.1.3zm3-4.5c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2-.1-.3 0 0 .1 0 .3.1.4zm3.1-4.6c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.3 0-.3.1-.1.1 0 .2.1.3zm16.6 13.4c0 .1.1.2.3.2.1 0 .2-.1.2-.2s-.1-.2-.3-.2c-.2-.1-.2 0-.2.2zm-28.8-14.5c.1.1.2.1.3.1.1-.1.1-.2.1-.3-.1-.1-.2-.1-.3-.1-.1.1-.2.2-.1.3zm4.5-3.1c.1.1.2.1.2.1.1 0 .1-.1.1-.2v-.1c-.1-.1-.2-.1-.3-.1v.3zM77.1 197c0 .1.1.2.2.3.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.1 0-.2.1-.3.2zm1.1-5.4c0 .1.1.2.2.3.1 0 .2 0 .3-.2 0-.1-.1-.2-.2-.3-.2 0-.3.1-.3.2zm-42.1-.2c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.6-.2-.3.2-.3.4-.2.6zm9-5.2c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.6-.2-.2.1-.3.3-.2.6zm9-5.3c.1.2.4.3.6.2.2-.1.3-.4.2-.6s-.4-.3-.6-.2c-.2.1-.3.4-.2.6zm7.9 42c-.1.2.1.5.3.5.2.1.5-.1.5-.3.1-.2-.1-.5-.3-.5-.2-.1-.4.1-.5.3zm2.7-10.1c-.1.2.1.5.3.5.2.1.5-.1.5-.3.1-.2-.1-.5-.3-.5-.2 0-.5.1-.5.3zm2.6-10.1c-.1.2.1.5.3.5.2.1.5-.1.5-.3.1-.2-.1-.5-.3-.5-.2 0-.4.1-.5.3zm2.7-10c-.1.2.1.5.3.5.2.1.5-.1.5-.3.1-.2-.1-.5-.3-.5-.2-.1-.5 0-.5.3 0-.1 0-.1 0 0zm-35.3-19.8c0 .2.3.4.5.4s.4-.3.4-.5-.3-.4-.5-.4-.4.2-.4.5zm9.7 36.3c.2.1.5.1.6-.1.1-.2.1-.5-.1-.6-.2-.1-.5-.1-.6.1-.1.2-.1.5.1.6zm6.3-8.3c.2.1.5.1.6-.1.1-.2.1-.5-.1-.6-.2-.1-.5-.1-.6.1-.1.2-.1.5.1.6zm6.3-8.3c.2.1.5.1.6-.1.1-.2.1-.5-.1-.6-.2-.1-.5-.1-.6.1s-.1.4.1.6zm6.4-8.3c.2.1.5.1.6-.1.1-.2.1-.5-.1-.6-.2-.1-.5-.1-.6.1-.2.2-.1.4.1.6-.1 0 0 0 0 0zm19.4 35.1c0 .2.3.4.5.4s.4-.2.4-.5c0-.2-.2-.4-.4-.4-.4 0-.5.3-.5.5zM81.4 209c0 .2.3.4.5.4s.4-.3.4-.5-.2-.4-.5-.4c-.3.1-.4.3-.4.5zM80 198.7c0 .2.2.4.5.4.2 0 .4-.2.4-.5 0-.2-.3-.4-.5-.4-.3.1-.5.3-.4.5zm-1.4-10.3c0 .2.3.4.5.4s.4-.2.4-.5c0-.2-.2-.4-.5-.4s-.5.2-.4.5zm-48.8-21.6c.1-.1.1-.2.1-.3 0-.1 0-.1-.1-.2.1.2 0 .4 0 .5zm6.6 36c.2.1.4.1.5 0 .1-.2.1-.4 0-.5-.2-.1-.4-.1-.5 0-.1.1-.1.4 0 .5zm6.4-6.8c.2.1.4.1.5 0 .1-.1.1-.4 0-.5-.2-.1-.4-.1-.5 0-.2.1-.2.3 0 .5-.1 0-.1 0 0 0zm6.2-7.1c0 .1 0 .2.1.3.2.1.4.1.5 0 .1-.2.1-.4 0-.6-.1-.1-.2-.1-.4-.1-.1 0-.1.1-.2.1 0 0-.1.2 0 .3zm6.4-6.6c.2.1.4.1.5 0 .1-.2.1-.4 0-.5-.2-.1-.4-.1-.5 0-.2.1-.2.3 0 .5zm17.7 33.8c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.1-.4.4zm-.3-9.3c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4c-.3 0-.5.2-.4.4zm-.4-9.4c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4c-.3.1-.4.2-.4.4zm-.4-9.2c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4-.4.1-.4.4zm-35.3-8c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.2.3-.2.5zm8.5-3.9c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5zm9.1 31.9c-.1.2 0 .4.2.5.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.5 0-.5.2zm3.2-8.8c-.1.2 0 .4.2.5.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5-.2-.1-.4 0-.5.2zm3.2-8.7c-.1.2 0 .4.2.5s.4 0 .5-.2 0-.4-.2-.5c-.2-.1-.4 0-.5.2zm3.2-8.7c-.1.2 0 .4.2.5h.3c.1 0 .1-.1.1-.2.1-.2 0-.4-.2-.5-.1-.1-.3 0-.4.2zm26 25.3c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2.1-.3.3-.2.5zm-3.9-8.4c.1.2.3.3.5.2.2-.1.3-.3.2-.5-.1-.2-.3-.3-.5-.2-.2 0-.3.3-.2.5zm-44.7-18.7c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0 0 .1-.1.2 0 .3zm4.4-3.2c.1.1.2.1.3 0 .1-.1.1-.2 0-.3-.1-.1-.2-.1-.3 0v.3zm15.4 15.1c0 .1.1.2.2.3.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.2 0-.3 0-.3.2zm.8-5.5c0 .1.1.2.2.3.1 0 .2-.1.3-.2 0-.1-.1-.2-.2-.3-.2 0-.3.1-.3.2zm-10.5-1c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2 0-.3.1 0 .1 0 .2.1.3zm2.9-4.7c.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3-.1-.1-.2 0-.3 0-.1.2 0 .3.1.4zm17.8 7.9c0 .1.1.2.3.2.1 0 .2-.1.2-.3 0-.1-.1-.2-.2-.2-.3.1-.3.2-.3.3zm-1.3-5.3c0 .1.2.2.3.2.1 0 .2-.2.2-.3 0-.1-.1-.2-.2-.2-.3 0-.3.2-.3.3zm-34.3 1.4c.1.1.3.1.4 0 .1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0-.2.1-.2.3 0 .4zm4.2-4.6c.1.1.3.1.4 0 .1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4zm4.3-4.6c.1.1.2.1.3 0 .1-.1.1-.3 0-.4-.1-.1-.3-.1-.4 0 0 .2 0 .3.1.4zm16.1 18.4c0 .1.1.2.2.2s.2-.1.2-.3c0-.1-.1-.3-.3-.3 0 .1-.2.2-.1.4zm-.2-6.3c0 .1.1.3.3.2.1 0 .2-.1.2-.3 0-.1-.1-.3-.3-.3-.1.1-.2.3-.2.4zm-.2-6.3c0 .1.1.2.2.3.1 0 .2-.1.2-.3 0-.1-.1-.3-.3-.3 0 .1-.1.2-.1.3zm-29.1-9.3c.1.1.2.2.3.1.1-.1.2-.2.1-.3-.1-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3zM49 188.9c.2.1.4.1.4-.1 0-.1 0-.3-.1-.3-.1-.1-.3 0-.3.1-.1.1-.1.2 0 .3zm2.1-6.2c-.1.1 0 .3.1.3.1.1.3 0 .3-.1s0-.3-.2-.3c0-.1-.1 0-.2.1zm21.8 5.6c.1.1.2.2.3.1.1-.1.2-.2.1-.3 0-.1-.2-.2-.3-.1-.1 0-.2.1-.1.3zM30 168.7c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.6-.2-.2.1-.3.3-.2.6zm4.4 43.8c-.1.2.1.5.3.6.2.1.5 0 .6-.3.1-.2 0-.5-.3-.6-.2-.1-.5.1-.6.3zm3.6-10.1c-.1.2 0 .5.3.6.2.1.5 0 .6-.3.1-.2 0-.5-.3-.6-.2-.1-.5 0-.6.3zm3.6-10.2c-.1.2 0 .5.3.6.2.1.5-.1.6-.3.1-.2-.1-.5-.3-.6-.2 0-.5.1-.6.3zm3.7-10.1c-.1.2 0 .5.3.6.2.1.5 0 .6-.3.1-.2 0-.5-.3-.6-.3 0-.6.1-.6.3zm34.4 28.5c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.6-.2-.2.1-.3.3-.2.6zm-4.6-9.8c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.6-.2-.3.2-.3.4-.2.6zm-4.7-9.7c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.6-.2-.2.2-.3.4-.2.6zm-38.3-9.9c.2.2.5.2.6 0 .2-.2.2-.5 0-.6-.2-.2-.5-.2-.6 0-.2.2-.1.5 0 .6zm7.2-8c.2.2.5.2.6 0 .2-.2.1-.5 0-.6-.2-.2-.5-.2-.6 0-.2.2-.1.5 0 .6zM56.2 211c0 .2.2.4.5.4.2 0 .4-.2.4-.5 0-.2-.2-.4-.4-.4-.3 0-.5.3-.5.5zm-.5-10.7c0 .2.2.4.5.4.2 0 .4-.2.4-.5 0-.2-.2-.4-.5-.4-.2 0-.4.2-.4.5zm-.6-10.8c0 .2.2.4.4.4s.4-.2.4-.5-.2-.4-.5-.4c-.1.1-.3.3-.3.5zM30 173.7c.2.2.5.2.6 0 .2-.2.2-.5 0-.6-.2-.2-.4-.2-.6 0-.1.1-.1.4 0 .6zm19.2 39.5c0 .2.2.4.5.4.2 0 .4-.2.4-.5 0-.2-.2-.4-.4-.4-.3 0-.5.2-.5.5zm-.1-10.7c0 .2.2.4.5.4.2 0 .4-.2.4-.4s-.2-.4-.5-.5c-.2 0-.4.2-.4.5zm-.1-10.7c0 .2.2.4.5.4.2 0 .4-.2.4-.4s-.2-.4-.4-.4c-.3-.1-.5.1-.5.4zm-.1-10.7c0 .2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4c-.2-.1-.4.1-.4.4zm-16.5 12.2c-.1.2 0 .5.2.6.2.1.5 0 .6-.2.1-.2 0-.5-.2-.6-.3-.2-.5-.1-.6.2zm4-10c-.1.2 0 .5.2.6s.5 0 .6-.2c.1-.2 0-.5-.2-.6-.2-.1-.5 0-.6.2zm4-9.9c-.1.2 0 .5.3.6.2.1.5 0 .6-.2.1-.2 0-.5-.2-.6-.3-.1-.6 0-.7.2zm29 30.1c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.3-.3-.6-.3-.2.2-.3.5-.2.7zm-4.2-9.8c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.3-.3-.6-.3-.2.2-.3.4-.2.7zm-4.2-9.9c.1.2.4.3.6.2.2-.1.3-.4.2-.6-.1-.2-.4-.3-.6-.2s-.3.4-.2.6zM32.5 169c.2.1.4.1.5-.1.1-.2.1-.4-.1-.5-.2-.1-.4-.1-.5.1-.1.1 0 .3.1.5zm20.3 26.1c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.3.2-.3.4zm-1.7-7.9c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3-.4.2-.3.4zm-1.8-7.9c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3c-.2.1-.3.2-.3.4zm-13.2 11.8c0 .2.1.4.3.4.2 0 .3-.1.4-.3 0-.2-.1-.4-.3-.4-.1 0-.3.1-.4.3zm1.4-8c0 .2.1.4.3.4.2 0 .4-.1.4-.3 0-.2-.1-.3-.2-.4-.2 0-.4.1-.5.3zm1.5-7.9c0 .2.1.3.2.4.2 0 .3-.1.4-.2 0-.2-.1-.4-.3-.4-.1-.1-.3 0-.3.2zm27.4 9.7c.1.1.3.2.4.1.2-.1.2-.3.1-.5-.1-.1-.3-.2-.5-.1 0 .2-.1.4 0 .5zm-28.9-11.7c0 .1.1.2.2.2s.2-.1.2-.2-.1-.2-.2-.2c-.2.1-.2.1-.2.2zm3.7 8c.1.2.2.2.4.2.1-.1.2-.2.2-.4 0-.1-.2-.2-.4-.2s-.3.2-.2.4zm-2.7-6.8c0 .1.2.2.4.2.2-.1.2-.2.2-.4-.1-.2-.2-.2-.4-.2-.1 0-.2.2-.2.4z",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "R_hand-i6_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4764.075",
                  y1: "-2222.457",
                  x2: "6453.054",
                  y2: "-2056.745",
                  gradientTransform: "matrix(.1015 0 0 -.1014 -310.6 1.752)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#R_hand-i6_1_)" },
              attrs: {
                id: "R_hand-i6",
                d: "M254.7 243.6c-9.9-1.5-22.8-4.9-25.8-9.1s6.8-6.1 9.1-12.5c2.3-6.5-1.9-7.2-3.8-4.9-4.4 4.9-9.2 9.3-14.4 13.3-5.7 4.2-6.8 4.9-18.2-1.5-11.4-6.5-24.3-19.7-24.3-19.7s-21.8-20.8-24.1-25.4l-22.9 45.1s20.6 4.7 26.2 5.6c9.8 1.1 29.6 3.2 54.7 20.2 25.1 17.1 36.8 12.1 47.8 1.9 10.9-10.4 5.6-11.5-4.3-13z",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                id: "sweater-i6",
                d: "M131.5 61.8S50.5 78.5 12 148.5c0 0 34.5 49.2 97.9 30.9 0 0 2.5-64.6 36.2-99.2 0 0-9.7 1.4-14.6-18.4",
              },
            }),
            _c("path", {
              staticClass: "st17",
              attrs: {
                id: "R_sleeve-i6",
                d: "M146.1 80.2s-22 56.3 11.4 100.7L127 236.6s-42.1-10-44.6-90.1 49-84.7 49-84.7 2.7 16 14.7 18.4",
              },
            }),
            _c(
              "linearGradient",
              {
                attrs: {
                  id: "neck-i6_1_",
                  gradientUnits: "userSpaceOnUse",
                  x1: "4458.732",
                  y1: "-807.656",
                  x2: "4519.536",
                  y2: "-335.53",
                  gradientTransform: "matrix(.1015 0 0 -.1014 -310.6 1.752)",
                },
              },
              [
                _c("stop", {
                  staticStyle: { "stop-color": "#ffbeb6" },
                  attrs: { offset: "0" },
                }),
                _c("stop", {
                  staticStyle: { "stop-color": "#f2a19c" },
                  attrs: { offset: "1" },
                }),
              ],
              1
            ),
            _c("path", {
              staticStyle: { fill: "url(#neck-i6_1_)" },
              attrs: {
                id: "neck-i6",
                d: "M159 54.8c-.7 1-11.5 18-13 25.5 0 0-11.2 0-14.6-18.4 0 0 7.5-4.9 10.6-11.9 1.8 2.1 7 3.5 10.6 4.1 2.2.4 4.3.6 6.4.7z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#ffbeb5" },
              attrs: {
                id: "face-i6",
                d: "M187.2 34.1c-2.8 2-3.6.8-4.4 2.6-.5 1.3-1.3 9-7.3 13.7l-.2.1-.1.1s0 .1-.1.1c-.6.5-3 2.4-7.9 3.1-3.2.5-6.9 1.7-14.6.2-3.3-.7-8.1-1.9-10.2-3.7 1.3-2.4 2.1-5-.1-6.2-4.6-2.4-7.3-3.2-6.5-9.1.6-5 6.7-5.5 10.9-5.1 3.6.3 18.8-7.2 22.9-26.3 2 .9 3.8 2.2 5.3 3.9 1.7 1.8 3 3.8 3.9 6.1 1.7 4.1 5.1 12.1 8 14.2 1.8 1.2 2.3 3.7 1.1 5.5-.1.3-.4.6-.7.8z",
              },
            }),
            _c("path", {
              staticStyle: { fill: "#3e8af8" },
              attrs: {
                id: "eyeglasses-i6",
                d: "M192.5 22.9c.4-3.5-1.4-6.9-3.9-7.7-2.6-.8-5 1.5-5.4 4.9 0 .4-.1.8-.1 1.2-1.6 0-3.1.7-4 2-.1-.2-.1-.4-.2-.6-.7-1.6-2-2.8-3.6-3.3-3-.9-5.8 1.7-6.2 5.7-.2 1.9.1 3.9.9 5.6.6 1.2 1.5 2.2 2.7 2.9.3.2.6.3.9.4 1.5.4 3 0 4.1-1.1 1.2-1.3 2-2.9 2.1-4.7.2-1.3 0-2.7-.3-4 .9-1 2.2-2.2 3.7-2v.2c.1.1.1.2.1.3.4 1.2 1 2.2 1.8 3.2l1.1 1.1.3.3c.1.1.2.2.4.3.1 0 .1 0 .2.1 2.6.9 5-1.3 5.4-4.8zM179 28.1c-.1 1.6-.8 3-1.9 4.2-.9.9-2.2 1.2-3.4.9-1.3-.5-2.4-1.5-3-2.8-.7-1.5-1-3.3-.8-5 .4-3.5 2.8-5.8 5.3-5.1.3.1.5.2.7.3 1 .6 1.8 1.4 2.2 2.5.8 1.6 1.1 3.3.9 5zm8.3-1.2c-2.1-.6-3.5-3.5-3.2-6.5.3-3 2.3-4.9 4.4-4.3 2.1.6 3.5 3.5 3.2 6.5-.4 3-2.3 4.9-4.4 4.3z",
              },
            }),
            _c("path", {
              staticClass: "st24",
              attrs: {
                id: "hair-i6",
                d: "M100 47.6c-.3.2-.6.5-.9.7-3.2 1.8-6.1 4.3-9.6 6-10 4.7-19.9-2.8-30-3.3-16-.8-29.4 10.5-32.5 25.9-.1.5.7.7.8.2 1.6-8.7 6.7-16.3 14.2-21 8.8-5.4 18.5-5.1 28.1-2.1 6 1.9 12.2 4 18.4 1.6 1.2-.5 2.4-1.1 3.5-1.7-9.8 7.5-11.6 6.8-26.5 2.7-18.2-5-30.5 10.3-32.2 24.6 0 0 14.5 13.1 27.4 13.7 0 0 25.9-20.1 70.7-33 3.3-2.3 6.3-5 8.8-8.2 0 0-22.6-20-40.2-6.1z",
              },
            }),
            _c("path", {
              staticClass: "st24",
              attrs: {
                id: "hair-2-i6",
                d: "M178.9 13.5s-3.2-9.2-9-10.9l-.3 1.4c.1-.5.2-.9.3-1.4 0 0-18.3-7.1-36.1 2.1s-17.5 45.4 5.2 50.5c0 0 8-8.6 3.5-11s-7.3-3.2-6.5-9.1c.6-4.5 5.5-5.4 9.5-5.2 1.8.6 3.6 1 5.5 1.1 3.8 0 7.6-1.2 10.6-3.5 7.1-5.1 9.2-14 8.3-22.3 1.5.8 7.5 3.8 9 8.3zm-29.7 16.4c-.3 0-.6-.1-.9-.1 4.9-1.2 16.4-8.3 20.7-23.6.7 11.7-5.9 25.6-19.8 23.7z",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }